<template>
<v-navigation-drawer
            v-model="drawer"
            :expand-on-hover="expandOnHover"
            :mini-variant="mini"
            :right="right" style="transform: translateX(0%)">

            <v-list nav class="py-0" style="margin-top:0.8rem">
              <!--<v-list-item style="color:#3e8ed0"
                v-for="item in itemsPower"
                :key="item.title"
                :to="item.to"
                link>

                <v-list-item-icon>
                  <v-icon style="margin-right:0.8rem">{{ item.icon }}</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title style="font-size:17px"><b>{{item.title }}</b></v-list-item-title>
                </v-list-item-content>
              </v-list-item>-->
              <v-list-item style="color:#3e8ed0"
                to="/playlists"
                link>

                <v-list-item-icon>
                  <v-icon style="margin-right:0.8rem">playlist_add_check</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title style="font-size:17px"><b>Playlists</b></v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <v-list-item style="color:#3e8ed0"
                to="/clusters"
                link>

                <v-list-item-icon>
                  <v-icon style="margin-right:0.8rem">tv</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title style="font-size:17px"><b>Clusters</b></v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <v-list-item style="color:#3e8ed0"
                to="/devices"
                link>

                <v-list-item-icon>
                  <v-icon style="margin-right:0.8rem">devices_other</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title style="font-size:17px"><b>Devices</b></v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <v-list-item v-if="addOns.powerDevices" style="color:#3e8ed0"
                to="/powerdevices"
                link>

                <v-list-item-icon>
                  <v-icon style="margin-right:0.8rem">power</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title style="font-size:17px"><b>Power devices</b></v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <v-list-item style="color:#3e8ed0"
                to="/menus"
                link>

                <v-list-item-icon>
                  <v-icon style="margin-right:0.8rem">menu_book</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title style="font-size:17px"><b>Menus</b></v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <v-list-item style="color:#3e8ed0"
                to="/offers"
                link>

                <v-list-item-icon>
                  <v-icon style="margin-right:0.8rem">star</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title style="font-size:17px"><b>Special Offers</b></v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <v-list-item v-if="addOns.documents" style="color:#3e8ed0"
                to="/documents"
                link>

                <v-list-item-icon>
                  <v-icon style="margin-right:0.8rem">description</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title style="font-size:17px"><b>Documents</b></v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <v-list-group
          :value="false"
          no-action
           @click="toggleAppMenu"
           v-if="addOns.appMenu"
        >
          <template v-slot:activator>
            <v-list-item-icon>
                  <v-icon style="margin-right:0.8rem">{{ am.icon }}</v-icon>
                </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title style="font-size:17px"><b>App Menu</b></v-list-item-title>
            </v-list-item-content>
                        <v-list-item-icon>
                  <v-icon v-if="arrowDownAM" style="margin-left:100%">arrow_drop_down</v-icon>
                  <v-icon v-else style="margin-left:100%">arrow_drop_up</v-icon>
                </v-list-item-icon>
          </template>

          <v-list-item
            style="color:#3e8ed0;margin-left:1rem"
                v-for="item in subItemsAM"
                :key="item.title"
                :to="item.to"
                link
                sub-group
          >
          <v-list-item-icon>
                  <v-icon style="margin-right:1.2rem">{{ item.icon }}</v-icon>
                </v-list-item-icon>
            <v-list-item-title><b>{{item.title}}</b></v-list-item-title>
          </v-list-item>
        </v-list-group>

              <v-list-item v-if="addOns.questionnaires" style="color:#3e8ed0"
                to="/questionnaires"
                link>

                <v-list-item-icon>
                  <v-icon style="margin-right:0.8rem">help</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title style="font-size:17px"><b>Questionnaires</b></v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <v-list-item v-if="addOns.questionnaires" style="color:#3e8ed0"
                to="/questionnaireanalytics"
                link>

                <v-list-item-icon>
                  <v-icon style="margin-right:0.8rem">bar_chart</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title style="font-size:17px"><b>Qtn Analytics</b></v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <v-list-item v-if="addOns.customerSatisfaction" style="color:#3e8ed0"
                to="/customersatisfaction"
                link>

                <v-list-item-icon>
                  <v-icon style="margin-right:0.8rem">sentiment_satisfied_alt</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title style="font-size:17px"><b>Customer Satisfaction</b></v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <v-list-item style="color:#3e8ed0"
                to="/analytics"
                link>

                <v-list-item-icon>
                  <v-icon style="margin-right:0.8rem">analytics</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title style="font-size:17px"><b>Analytics</b></v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <v-list-group
          :value="false"
          no-action
           @click="toggleStorage"
        >
          <template v-slot:activator>
            <v-list-item-icon>
                  <v-icon style="margin-right:0.8rem">{{ stor.icon }}</v-icon>
                </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title style="font-size:17px"><b>Storage</b></v-list-item-title>
            </v-list-item-content>
                        <v-list-item-icon>
                  <v-icon v-if="arrowDown" style="margin-left:100%">arrow_drop_down</v-icon>
                  <v-icon v-else style="margin-left:100%">arrow_drop_up</v-icon>
                </v-list-item-icon>
          </template>

          <v-list-item
            style="color:#3e8ed0;margin-left:1rem"
                v-for="item in subItems"
                :key="item.title"
                :to="item.to"
                link
                sub-group
          >
          <v-list-item-icon>
                  <v-icon style="margin-right:1.2rem">{{ item.icon }}</v-icon>
                </v-list-item-icon>
            <v-list-item-title><b>{{item.title}}</b></v-list-item-title>
          </v-list-item>
        </v-list-group>
        <v-list-item v-if="addOns.tickets" style="color:#3e8ed0"
            to="/tickets"
            link>

            <v-list-item-icon>
              <v-icon style="margin-right:0.8rem">contact_support</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title style="font-size:17px"><b>Tickets</b></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
        </v-list>
      </v-navigation-drawer>
      </template>

<script>
// import * as firebase from 'firebase'

export default {
  name: 'SideMenu',
  data: () => {
    return {
      // user: firebase.auth().currentUser,
      drawer: true,
      right: false,
      mini: false,
      expandOnHover: false,
      background: false,
      arrowDown: true,
      arrowDownAM: true,
      stor: {
        icon: 'storage'
      },
      am: {
        icon: 'grid_on'
      },
      subItems: [
        { title: 'Playlists', icon: 'horizontal_rule', to: '/playlistsstorage' },
        { title: 'Menus', icon: 'horizontal_rule', to: '/menusstorage' },
        { title: 'Special Offers', icon: 'horizontal_rule', to: '/specialoffersstorage' }
      ],
      subItemsAM: [
        { title: 'Tiles', icon: 'horizontal_rule', to: '/appmenu' },
        { title: 'PDFs', icon: 'horizontal_rule', to: '/appmenupdfs' }
      ]
    }
  },
  computed: {
    addOns () {
      return this.$store.state.addOns
    }
  },
  methods: {
    toggleStorage () {
      this.arrowDown = !this.arrowDown
    },
    toggleAppMenu () {
      this.arrowDownAM = !this.arrowDownAM
    }
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/SideMenu.vue